import {InputNumber, type InputNumberProps} from "antd";
import {forwardRef} from "react";
import {getSeparators, localizedNumberFormatter} from "@/helpers/numberFormatHelper.tsx";

/**
 * Ein InputNumber-Wrapper, der automatisch das richtige Dezimaltrennzeichen
 * basierend auf der angegebenen Locale (Standard: de-DE) nutzt.
 *
 * Unterstützt z. B. Komma (,) oder Punkt (.)
 */
export const InputNumberLocalized = forwardRef<
    HTMLInputElement,
    InputNumberProps<number | string>
>(function InputNumberLocalized(props, ref) {
  const formatter: InputNumberProps<number | string>["formatter"] = (value) => {
    return localizedNumberFormatter(value);
  };

  const parser: InputNumberProps<number | string>["parser"] = (displayValue) => {
    const {decimal, group} = getSeparators();
    const raw = displayValue?.toString() ?? "";

    let v = raw
        .replaceAll(group, "")
        .replaceAll(decimal, ".")
        .replace(/[^\d.\-]/g, "");

    v = v.replace(/(?!^)-/g, "");

    const firstDot = v.indexOf(".");
    if (firstDot !== -1) {
      v = v.slice(0, firstDot + 1) + v.slice(firstDot + 1).replaceAll(".", "");
    }

    return v as unknown as number;
  };

  return (
      <InputNumber<number | string>
          ref={ref}
          {...props}
          formatter={formatter}
          parser={parser}
      />
  );
});

InputNumberLocalized.displayName = "InputNumberLocalized";
